<template>
  <div class="course-add-other">
    <div class="course-choose-title-container">
      <div class="course-choose-title">添加自定义科目</div>
    </div>
    <div class="course-list-container">
      <el-tag
        :key="index"
        v-for="(courseName, index) in addCourseList"
        closable
        :disable-transitions="false"
        @close="handleClose(courseName)"
      >
        {{ courseName }}
      </el-tag>
      <el-input
        class="input-new-tag"
        v-if="inputVisible"
        v-model.trim="inputValue"
        ref="saveTagInput"
        @keyup.enter.native="handleInputConfirm"
        @blur="handleInputConfirm"
      >
      </el-input>
      <el-button v-else class="button-new-tag" @click="showInput">
        <i class="iconfont icon-add" />添加科目
      </el-button>
    </div>
    <div class="button-container">
      <button
        class="submit-button"
        :disabled="addCourseList.length == 0"
        :class="{ 'not-selected': addCourseList.length == 0 }"
        @click="submitAddCourseList"
      >
        添加
      </button>
      <button class="cancel-button" @click="cancel">取消</button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  props: {
    courseList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      addCourseList: [],
      submitCourseList: [],
      inputVisible: false,
      inputValue: "",
    };
  },
  created() {},
  methods: {
    handleClose(tag) {
      this.addCourseList.splice(this.addCourseList.indexOf(tag), 1);
      // console.log(this.addCourseList);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        let haveCourse = false;
        this.courseList.forEach((item) => {
          if (item.courseName == inputValue) {
            haveCourse = true;
          }
        });
        if (haveCourse == true) {
          return this.$message.warning("当前科目已存在，请勿重复添加");
        }
        this.addCourseList.push(inputValue);
        // console.log(this.addCourseList);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    submitAddCourseList() {
      // console.log(this.addCourseList);
      let submitCourseList = [];
      this.addCourseList.forEach((item) => {
        submitCourseList.push({
          createBy: this.user.id,
          schoolId: this.user.schoolId,
          schoolName: this.user.schoolName,
          courseName: item,
        });
      });
      this.submitCourseList = submitCourseList;
      // console.log("this.submitCourseList=>", this.submitCourseList);
      this.$emit("submitCourseList", this.submitCourseList);
      // 清空数据
      setTimeout(() => {
        this.inputVisible = false;
        this.inputValue = "";
        this.addCourseList = [];
        this.submitCourseList = [];
      }, 100);
    },
    // 取消
    cancel() {
      // 清空数据
      this.inputVisible = false;
      this.inputValue = "";
      this.addCourseList = [];
      this.submitCourseList = [];
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped lang="scss">
@import "./course-add-other.scss";
</style>